import styles from './ExtraTimeSelector.module.scss';
import headerActionStyles from '../HeaderActionButtons.module.scss';
import React, { useRef, useState } from 'react';
import { Settings } from 'lucide-react';
import useOutsideClick from '../../../../../../utils/useOutsideClick';
import clx from 'classnames';
import CalendarSettingsContent from '../CalendarSettingsContent';

export default ({
  startDay,
  title = '',
  daySettings = true,
  searchParams,
}) => {
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useOutsideClick(dropdownRef, () => {
    if (isDropdownOpen) setIsDropdownOpen(false);
  });

  return (
    <div
      ref={dropdownRef}
      className={clx(styles.extra_time_selector, {
        [styles.extra_time_selector_close]: !isDropdownOpen,
      })}
    >
      <button
        type="button"
        className={clx(headerActionStyles.action_button, {
          [headerActionStyles.action_button_active]: isDropdownOpen,
        })}
        onClick={() => setIsDropdownOpen((open) => !open)}
        aria-expanded={isDropdownOpen}
        aria-haspopup="menu"
      >
        <Settings size={18} strokeWidth={2} />
        <span>{title}</span>
      </button>
      <div className={styles.dropdown__menu} role="menu">
        <div className={styles.dropdown__menu_inner_list}>
          {isDropdownOpen ? (
            <CalendarSettingsContent
              startDay={startDay}
              daySettings={daySettings}
              searchParams={searchParams}
              variant="dropdown"
              onAction={() => setIsDropdownOpen(false)}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
